
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 24a.75.75 0 01-.659-.391l-4.168-7.641a3.698 3.698 0 01-1.173.455v6.827a.75.75 0 01-1.5 0v-6.83a3.787 3.787 0 01-1.172-.454l-4.17 7.644a.749.749 0 01-1.018.298.752.752 0 01-.299-1.017l4.349-7.974a3.711 3.711 0 01-.603-1.364l-3.146 1.58a2.696 2.696 0 01-2.079.152 2.694 2.694 0 01-1.147-.741l-1.63.82a.753.753 0 01-1.007-.333.745.745 0 01.333-1.006l1.631-.82a2.71 2.71 0 011.45-2.938L9.561 7.22a2.726 2.726 0 011.427-1.825l6.068-3.046A2.724 2.724 0 0118.484.523l.883-.444a.758.758 0 01.572-.041c.188.062.347.2.435.376l3.547 7.058a.745.745 0 01-.333 1.006l-.882.443a2.7 2.7 0 01-2.08.152 2.702 2.702 0 01-.238-.092l-4.26 2.14a3.72 3.72 0 01.182 2.804 3.715 3.715 0 01-.502.991l4.349 7.974a.743.743 0 01.061.571.743.743 0 01-.718.539zm-7.958-13.148a2.267 2.267 0 00-.802 2.909 2.24 2.24 0 002.014 1.238c.352 0 .691-.081 1.007-.24.536-.27.935-.733 1.124-1.304a2.237 2.237 0 00-.125-1.717 2.243 2.243 0 00-2.014-1.238 2.218 2.218 0 00-1.182.34l-.022.012zm-7.373.754a1.228 1.228 0 00-.547 1.639 1.22 1.22 0 001.645.549l3.844-1.931a3.75 3.75 0 011.127-1.895l-.565-1.126-5.504 2.764zm8.578-2.603c.895 0 1.773.328 2.449.908l3.957-1.988-1.986-3.952-5.505 2.764a1.228 1.228 0 00-.544 1.643l.013.029.401.799a3.715 3.715 0 011.215-.203zm6.411-7.14a1.228 1.228 0 00-.544 1.644l1.774 3.531a1.22 1.22 0 001.643.544l.212-.106-2.873-5.72-.212.107z"}})])
          )
        }
      }
    